export default "__VITE_ASSET__BHX6DeZX__"